import { Language } from '@consigli/types';

export const languageOptions = [
  { label: 'English', value: Language.EN },
  { label: 'French', value: Language.FR },
  { label: 'German', value: Language.DE },
  { label: 'Japanese', value: Language.JA },
  { label: 'Norwegian Bokmål', value: Language.NB },
  { label: 'Norwegian Nynorsk', value: Language.NN },
  { label: 'Spanish', value: Language.ES },
  { label: 'Catalan', value: Language.CA },
  { label: 'Swedish', value: Language.SV },
  { label: 'Vietnamese', value: Language.VI },
  { label: 'Chinese', value: Language.ZH },
];

export type UploadBlobsFunction = (files: File[], packageId: string) => Promise<unknown>;
